<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_NOT_FULLY_PAID_INVOICES' | translate }}</h1>
    <astral-popover [helpText]="'REPORT.HEADER_TOOLTIP.NOT_FULLY_PAID_INVOICES'"></astral-popover>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote-paged
        [service]="companyService"
        [defaultSearch]="'*'"
        [control]="form.controls['company']"
      ></app-autocomplete-remote-paged>
      <astral-date-picker
        [control]="form.controls['reconciliationTo']"
        [model]="reconciliationTo"
        [label]="'REPORT.RECONCILIATION_DATE'"
        [isRequired]="true"
      ></astral-date-picker>
      <astral-select [control]="form.controls['groupLevel']" [itemsSource]="groupSelection"></astral-select>
      <astral-select [control]="form.controls['personalData']" [itemsSource]="personalDataSelection"></astral-select>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      @if ((dataContext && dataContext.length) || (futureInvoices && futureInvoices.length)) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          [labelKey]="!expandAllRows ? 'COMMON.EXPAND_ALL' : 'COMMON.COLLAPSE_ALL'"
          (click)="toggleExpandAllRows()"
        ></astral-button>
      }
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [expandAllRows]="expandAllRows"
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      [preferencesKey]="'report.not-fully-paid-invoices'"
    ></app-expanded-list-view>
  }
  @if (futureInvoices && futureInvoices.length) {
    <app-expanded-list-view
      [columnDefinitions]="futureInvoicesColumnDefinitions"
      [itemsSource]="futureInvoices"
      [expandAllRows]="expandAllRows"
      [preferencesKey]="'report.not-fully-paid-invoices.future'"
    ></app-expanded-list-view>
  }
</section>
